/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import lang from 'quasar/lang/en-us';
import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import Ripple from 'quasar/src/directives/Ripple.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Notify from 'quasar/src/plugins/Notify.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';import Loading from 'quasar/src/plugins/Loading.js';import Dialog from 'quasar/src/plugins/Dialog.js';;
Vue.use(Quasar, {
  config: {},
  lang: lang,
  directives: {
    Ripple: Ripple,
    ClosePopup: ClosePopup
  },
  plugins: {
    Notify: Notify,
    LocalStorage: LocalStorage,
    SessionStorage: SessionStorage,
    Loading: Loading,
    Dialog: Dialog
  }
});